import React from 'react'
import './Banner.css'
import '../../App.css'
import {Fade, Zoom} from 'react-reveal'
import { Link } from 'react-router-dom'
export const Banner = () => {
  return (
   <section className="banner-wrapper">
       <div className="container  text-center start-up-academy-container">
         <Fade>
             <Zoom>

             </Zoom>
           <h2 id='start-up-academy'> THE STARTUP ACADEMY</h2>
           <span className="subtitle">
           Let's start with understanding how to get started as an early-stage entrepreneur.
           </span>
           <p>
           If you want to start a business, but aren't sure what kind to start, Lacuna Venture Startup Academy will show you strategies for brainstorming your next great business idea. 
           </p>
            <h2 className='bc'>Create your own <span>vision</span> for <span>success.</span></h2>
           <button className='enroll-btn'>
           <Link to='/membership'>Enroll Now</Link>
           </button>
         </Fade>
       </div>
   </section>
  )
}
